import React from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";

// Pages
import Landing from "./pages/Landing";
import AuthCallback from "./pages/AuthCallback";
import RoleSelect from "./pages/RoleSelect";
import TeacherDashboard from "./pages/TeacherDashboard";
import StudentDashboard from "./pages/StudentDashboard";
import ClassroomView from "./pages/ClassroomView";
import CreateExercise from "./pages/CreateExercise";
import TypingExercise from "./pages/TypingExercise";
import QuizPage from "./pages/QuizPage";
import ResultsPage from "./pages/ResultsPage";
import ProgressPage from "./pages/ProgressPage";
import ReportsPage from "./pages/ReportsPage";
import ObjectivesPage from "./pages/ObjectivesPage";
import AdminDashboard from "./pages/AdminDashboard";
import QuestionAnalytics from "./pages/QuestionAnalytics";
import ClassReports from "./pages/ClassReports";
import Leaderboard from "./pages/Leaderboard";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH

function AppRouter() {
  const location = useLocation();
  
  // Check URL fragment for session_id synchronously during render
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/role-select" element={<RoleSelect />} />
      <Route path="/teacher" element={<TeacherDashboard />} />
      <Route path="/student" element={<StudentDashboard />} />
      <Route path="/classroom/:classroomId" element={<ClassroomView />} />
      <Route path="/create-exercise" element={<CreateExercise />} />
      <Route path="/exercise/:exerciseId" element={<TypingExercise />} />
      <Route path="/quiz/:exerciseId/:sessionId" element={<QuizPage />} />
      <Route path="/results/:exerciseId/:sessionId" element={<ResultsPage />} />
      <Route path="/progress" element={<ProgressPage />} />
      <Route path="/reports/:classroomId" element={<ReportsPage />} />
      <Route path="/class-reports/:classroomId" element={<ClassReports />} />
      <Route path="/leaderboard/:classroomId" element={<Leaderboard />} />
      <Route path="/leaderboard" element={<Leaderboard />} />
      <Route path="/objectives" element={<ObjectivesPage />} />
      <Route path="/analytics" element={<QuestionAnalytics />} />
      <Route path="/admin" element={<AdminDashboard />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Toaster position="top-right" richColors />
      <AppRouter />
    </BrowserRouter>
  );
}

export default App;
